import { IFileDocument, IFileDocumentData } from './interfaces/files.interface';


export const OCR_SUPPORTED_FILE_TYPES = ['.png', '.pdf', '.jpg', '.jpeg', 'bmp', 'jfif'];

export class FileDocumentData implements IFileDocument {
  public readonly id: string;
  public readonly name: string;
  public readonly contentType: string;
  public readonly size: number;
  public readonly fileExtension: string;
  public readonly fileURI: string;
  public readonly fileType: string;
  public data: IFileDocumentData;

  constructor(fileDocument: IFileDocument, fileData: IFileDocumentData) {
    this.id = fileDocument.id;
    this.name = fileDocument.name;
    this.contentType = fileDocument.contentType;
    this.size = fileDocument.size;
    this.fileExtension = fileDocument.fileExtension;
    this.fileURI = fileDocument.fileURI;
    this.fileType = fileDocument.fileType;
    this.data = fileData;
  }
}